import { IconAlertTriangle, IconMessage } from '@rossum/ui/icons/tabler';
import { Stack, SvgIcon, Tooltip } from '@rossum/ui/material';
import HTMLMessage from '../../../components/DatapointMessage/HTMLMessage';

const MAX_MESSAGE_LENGTH = 1000;

type NoteProps<T> = {
  messages?: Array<T>;
};

const Note = <
  T extends { type: 'error' | 'warning' | 'info'; content: string },
>({
  messages,
}: NoteProps<T>) => {
  const firstMessage = messages ? messages[0] : undefined;

  if (!firstMessage) return null;

  const message = firstMessage.content;

  const truncatedMessage =
    message.length > MAX_MESSAGE_LENGTH
      ? `${message.substring(0, MAX_MESSAGE_LENGTH)}...`
      : message;

  return (
    <Tooltip
      title={
        <Stack direction="column" spacing={0.5} alignItems="center">
          <SvgIcon
            fontSize="medium"
            color={firstMessage.type === 'info' ? 'action' : firstMessage.type}
          >
            <IconAlertTriangle />
          </SvgIcon>
          <HTMLMessage content={truncatedMessage} />
        </Stack>
      }
      placement="top"
    >
      <SvgIcon fontSize="medium">
        <IconMessage />
      </SvgIcon>
    </Tooltip>
  );
};

export { Note };
